// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  height: 100px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  max-width: 8em;
  max-height: 8em;
}

.logo h2 {
  font-size: 18px;
  font-weight: normal;
}

.nav-social-container {
  display: flex;
  align-items: center;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 20px;
}

.nav-links li {
  margin: 0 15px;
}

.nav-links a {
  text-decoration: none;
  color: #333;
  font-size: 1em;
}

.nav-links a:hover {
  color: #007bff;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropbtn {
  background-color: #ffffff;
  color: #333;
  border: none;
  cursor: pointer;
  font-size: 1em;
}

.dropbtn:hover {
  color: #007bff;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 1;
  min-width: 200px;
}

.dropdown-content a {
  display: block;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.social-links {
  display: flex;
  align-items: center;
}

.social-link {
  margin-left: 15px;
  text-decoration: none;
}

.social-icon {
  width: 24px;
  height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".header {\r\n  background-color: #ffffff;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  position: fixed;\r\n  width: 100%;\r\n  top: 0;\r\n  z-index: 1000;\r\n  height: 100px;\r\n}\r\n\r\n.header-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 0 auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n.logo {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.logo img {\r\n  max-width: 8em;\r\n  max-height: 8em;\r\n}\r\n\r\n.logo h2 {\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n}\r\n\r\n.nav-social-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.nav-links {\r\n  list-style: none;\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: auto;\r\n  margin-right: 20px;\r\n}\r\n\r\n.nav-links li {\r\n  margin: 0 15px;\r\n}\r\n\r\n.nav-links a {\r\n  text-decoration: none;\r\n  color: #333;\r\n  font-size: 1em;\r\n}\r\n\r\n.nav-links a:hover {\r\n  color: #007bff;\r\n}\r\n\r\n.dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.dropbtn {\r\n  background-color: #ffffff;\r\n  color: #333;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 1em;\r\n}\r\n\r\n.dropbtn:hover {\r\n  color: #007bff;\r\n}\r\n\r\n.dropdown-content {\r\n  display: none;\r\n  position: absolute;\r\n  background-color: #f9f9f9;\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  z-index: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n.dropdown-content a {\r\n  display: block;\r\n  color: black;\r\n  padding: 12px 16px;\r\n  text-decoration: none;\r\n}\r\n\r\n.dropdown-content a:hover {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n\r\n.social-links {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.social-link {\r\n  margin-left: 15px;\r\n  text-decoration: none;\r\n}\r\n\r\n.social-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
